module.exports = window.wp.tokenList;